import { createRender } from './types';
import { RovoAwarenessHomeBannerComponent } from './components';

export const render = createRender(({ onDismissed }) => (
	<RovoAwarenessHomeBannerComponent onDismissed={onDismissed} />
));

export default render;
